import { render, staticRenderFns } from "./ProductItemDetailPage.vue?vue&type=template&id=d24c8920&scoped=true"
import script from "./ProductItemDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductItemDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ProductItemDetailPage.vue?vue&type=style&index=0&id=d24c8920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24c8920",
  null
  
)

export default component.exports